import type * as React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Col, PrimaryButton, Row } from '@crehana/ui';
import { useUITheme } from '@crehana/web';
import { clsx } from 'clsx';

export interface DashboardEmptyViewProps {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  button?: {
    label: string;
    href?: string;
    onClick?: () => void;
    'data-testid'?: string;
  };
  supportsDarkMode?: boolean;
  'data-testid'?: string;
}

const DashboardEmptyView: FC<
  React.PropsWithChildren<DashboardEmptyViewProps>
> = ({
  className = '',
  title,
  description,
  button,
  supportsDarkMode,
  'data-testid': dataTestId,
}) => {
  const { isDark } = useUITheme();
  const dark = supportsDarkMode && isDark;
  const textColor = dark ? 'text-white' : 'text-base-main';

  return (
    <div
      className={clsx(
        'w-full',
        dark ? 'bg-base-lighter-24' : 'bg-base-lighter-16',
        className,
      )}
      data-testid={dataTestId}
    >
      <Row nowrap className="flex justify-center">
        <Col xs={12} sm={10} lg={8}>
          <div className="flex flex-col items-center text-center py-16 px-16 sm:py-32 sm:px-0">
            {typeof title === 'string' ? (
              <h4 className={`font-h4 whitespace-pre-line ${textColor}`}>
                {title}
              </h4>
            ) : (
              title
            )}
            {typeof description === 'string' ? (
              <span
                className={`font-body3 whitespace-pre-line ${textColor}${
                  title ? ' mt-16' : ''
                }`}
              >
                {description}
              </span>
            ) : (
              description
            )}
            {button && (
              <PrimaryButton
                className={`w-full sm:w-auto ${
                  title || description ? 'mt-16' : ''
                }`}
                size="l"
                darkMode={dark}
                {...button}
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardEmptyView;
